import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Slider from '../../../components/Slider/Slider';
import Placeholder from '../../../components/Placeholder';

import {
  Section,
  GridWrapper,
  Title,
  SliderWrapper,
  InstructorCell,
  Name,
  PlaceholderWrapper,
  GridWrapperJp,
  InstructorCellJp,
  GridWrapperSectionJp,
  MoreButtonWrap,
  MoreButton,
} from './Instructors.style';

const InstructorGallery = ({ instructors,region }) => (
  <Fragment>
    {instructors ? region === 'Japan' ? 
      instructors.map(instructor => (
        <InstructorCellJp url={instructor.image.file.url} key={instructor.image.file.url}>
          <Name>{instructor.name}</Name>
        </InstructorCellJp>
      )) : 
        instructors.map(instructor => (
          <InstructorCell url={instructor.image.file.url} key={instructor.image.file.url}>
            <Name>{instructor.name}</Name>
          </InstructorCell>
        ))
      
    : (
      <Fragment>
        <PlaceholderWrapper>
          <Placeholder w="100%" h="100%" />
        </PlaceholderWrapper>
        <PlaceholderWrapper>
          <Placeholder w="100%" h="100%" />
        </PlaceholderWrapper>
        <PlaceholderWrapper>
          <Placeholder w="100%" h="100%" />
        </PlaceholderWrapper>
      </Fragment>
    )}
  </Fragment>
);

InstructorGallery.defaultProps = {
  instructors: undefined,
};

InstructorGallery.propTypes = {
  instructors: PropTypes.arrayOf(PropTypes.shape({})),
};

/**
 * 「セミナー」画面 > 「セミナーのご案内」画面 > インストラクター
 */
const Instructors = ({ copy, instructors, region, locale, ancestor }) => (
  <Section id="instructors-section">
    <Title>{copy.instructors || <Placeholder h="20px" w="150px" />}</Title>
    <SliderWrapper>
      {instructors ? (
        <Slider options={{ loop: false }} dots={false}>
          <InstructorGallery instructors={instructors} region={region} />
        </Slider>
      ) : (
        <Placeholder w="100%" h="250px" />
      )}
    </SliderWrapper>
    {region === 'Japan' ? (
      <GridWrapperSectionJp>
        <GridWrapperJp>
          <InstructorGallery instructors={instructors} region={region} />
        </GridWrapperJp>
        <MoreButtonWrap>
          <Link
            to={{
              pathname: `/${locale}/creators`,
              state: {
                ancestor,
              },
            }}
            href={`/${locale}/creators`}
          >
            詳しくはこちら
          </Link>
        </MoreButtonWrap>
      </GridWrapperSectionJp>
    ) : (
      <GridWrapper>
        <InstructorGallery instructors={instructors} region={region} />
      </GridWrapper>
    )}
  </Section>
);

Instructors.defaultProps = {
  instructors: undefined,
};

Instructors.propTypes = {
  copy: PropTypes.shape().isRequired,
  ancestor: PropTypes.string.isRequired,
  instructors: PropTypes.arrayOf(PropTypes.shape()),
  locale: PropTypes.string,
};

export default Instructors;



// WEBPACK FOOTER //
// ./src/pages/SeminarSchedulePage/Instructors/Instructors.js